import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "icon" }
const _hoisted_2 = {
  key: 0,
  class: "badge bg-danger text-white"
}
const _hoisted_3 = { class: "descr" }

import {computed} from 'vue';
import {OperatorApplicationMenuItem} from "~/operatorApplication/vue/layout/Interface";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";



const __default__ = {
    name: "OperatorApplicationMainMenuItem"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    selected: { type: Boolean },
    item: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let badgeValue = computed(() => {
    if (props.item.badgeValueGetter) {
        return props.item.badgeValueGetter();
    } else {
        return null;
    }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('click'))),
    class: _normalizeClass({
            selected: __props.selected,
            'menu-item': true
        })
  }, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        (_unref(badgeValue))
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              (_unref(badgeValue) === '@')
                ? (_openBlock(), _createBlock(FontAwesomeIcon, {
                    key: 0,
                    icon: "at",
                    style: {"transform":"scale(.9)"}
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_unref(badgeValue)), 1)
                  ], 64))
            ]))
          : _createCommentVNode("", true),
        _createVNode(FontAwesomeIcon, {
          icon: __props.item.icon,
          light: ""
        }, null, 8, ["icon"])
      ]),
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.item.descr), 1)
    ])
  ], 2))
}
}

})